document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.order-section-block');

	sections.forEach((section) => {
		const phone = section.querySelector('g.phone');
		const waves = section.querySelectorAll('g.phone-waves path');

		if (typeof gsap === 'undefined' || !phone) return;

		const master = gsap.timeline({
			repeat: -1,
			repeatDelay: 3,
		});

		// --- Phone rocking ---
		const phoneTl = gsap.timeline();

		phoneTl
			// Ease in: progressively wider rotations
			.to(phone, {
				rotation: 3,
				duration: 0.25,
				ease: 'power1.in',
				transformOrigin: 'center center',
			})
			.to(phone, { rotation: -3, duration: 0.25, ease: 'power1.inOut' })
			.to(phone, { rotation: 6, duration: 0.2, ease: 'power1.inOut' })
			.to(phone, { rotation: -6, duration: 0.2, ease: 'power1.inOut' })
			.to(phone, { rotation: 10, duration: 0.15, ease: 'power1.inOut' })
			.to(phone, { rotation: -10, duration: 0.15, ease: 'power1.inOut' })
			// Full speed
			.to(phone, {
				rotation: 12,
				duration: 0.13,
				repeat: 10,
				yoyo: true,
				ease: 'power1.inOut',
			})
			// Ease out: progressively narrower rotations
			.to(phone, { rotation: -8, duration: 0.18, ease: 'power1.inOut' })
			.to(phone, { rotation: 8, duration: 0.18, ease: 'power1.inOut' })
			.to(phone, { rotation: -4, duration: 0.22, ease: 'power1.inOut' })
			.to(phone, { rotation: 4, duration: 0.22, ease: 'power1.inOut' })
			.to(phone, { rotation: 0, duration: 0.3, ease: 'power2.out' });

		// --- Waves (interleaved with phone) ---
		// Fade in as phone ramps up, loop while shaking, fade out as phone slows
		const waveTl = gsap.timeline();

		if (waves.length > 0) {
			waveTl
				// Appear during ramp-up
				.fromTo(
					waves,
					{ opacity: 0, scale: 0.6, transformOrigin: 'left center' },
					{
						opacity: 1,
						scale: 1,
						duration: 0.5,
						ease: 'sine.out',
					}
				)
				// Pulse while phone shakes at full speed
				.to(waves, {
					opacity: 0.4,
					scale: 0.85,
					duration: 0.4,
					repeat: 5,
					yoyo: true,
					ease: 'sine.inOut',
					stagger: 0.1,
				})
				// Fade out as phone slows down
				.to(waves, {
					opacity: 0,
					scale: 0.5,
					duration: 0.5,
					stagger: 0.1,
					ease: 'sine.in',
				});
		}

		// Add both to master at position 0 so they start simultaneously
		master.add(phoneTl, 0).add(waveTl, 0.5);
	});
});
